<template>
  <div class="my_form">
    <div>
        <h1>
            <i class="el-icon-s-order icon"></i>
            待批准借用
        </h1>
        <STable :columns="columns" :loadData="loadData1" ref="table0">
          <template #sn='{ $index }'>
            {{ $index + 1 }}
          </template>
          <template #allow="record">
            {{borrowStatus[record.row.allow]}}
          </template>
          <template #license_type="record">
            {{licenseList.find(item => item.license_id === record.row.license_id) ? licenseType[licenseList.find(item => item.license_id === record.row.license_id).license_type]:''}}
          </template>
          <template #approve="record">
            {{ filterPeople(record.row.approve) }}
          </template>
          <template #user_id="record">
            {{ filterPeople(record.row.user_id) }}
          </template>
          <template #license_id="record">
            <a v-if="licenseList.find(item => item.license_id === record.row.license_id)" href="javascript:;" @click="handleOpenDetail(record.row.license_id)">
                {{ licenseList.find(item => item.license_id === record.row.license_id).license_no }}
            </a>
          </template>
          <template #action="record">
              <a href="javascript:;" @click="handleDelete(record.row ,'0')">撤销</a>
          </template>
        </STable>
    </div>
    <div>
        <h1>
            <i class="el-icon-s-order icon"></i>
            已批准借用
        </h1>
        <STable :columns="columns" :loadData="loadData2" ref="table1">
          <template #sn='{ $index }'>
            {{ $index + 1 }}
          </template>
          <template #allow="record">
            {{borrowStatus[record.row.allow]}}
          </template>
          <template #license_id="record">
            <a v-if="licenseList.find(item => item.license_id === record.row.license_id)" href="javascript:;" @click="handleOpenDetail(record.row.license_id)">
                {{ licenseList.find(item => item.license_id === record.row.license_id).license_no }}
            </a>
          </template>
          <template #approve="record">
            {{ filterPeople(record.row.approve) }}
          </template>
          <template #user_id="record">
            {{ filterPeople(record.row.user_id) }}
          </template>
          <template #license_type="record">
             {{licenseList.find(item => item.license_id === record.row.license_id) ? licenseType[licenseList.find(item => item.license_id === record.row.license_id).license_type] : '' }}
          </template>
          <template #action="record">
              <a href="javascript:;" @click="handleBorrow(record.row ,'3','1')">归还</a>
          </template>
        </STable>

    </div>
    <div>
        <h1>
            <i class="el-icon-s-order icon"></i>
            未批准借用
        </h1>
        <STable :columns="columns" :loadData="loadData3" ref="table2">
          <template #sn='{ $index }'>
            {{ $index + 1 }}
          </template>
          <template #allow="record">
            {{borrowStatus[record.row.allow]}}
          </template>
          <template #license_id="record">
            <a v-if="licenseList.find(item => item.license_id === record.row.license_id)" href="javascript:;" @click="handleOpenDetail(record.row.license_id)">
                {{ licenseList.find(item => item.license_id === record.row.license_id).license_no }}
            </a>
          </template>
          <template #approve="record">
            {{ filterPeople(record.row.approve) }}
          </template>
          <template #user_id="record">
            {{ filterPeople(record.row.user_id) }}
          </template>
          <template #license_type="record">
             {{ licenseList.find(item => item.license_id === record.row.license_id) ? licenseType[licenseList.find(item => item.license_id === record.row.license_id).license_type] : '' }}
          </template>
          <template #action="record">
              <a href="javascript:;" @click="handleDelete(record.row ,'2')">删除</a>
          </template>
        </STable>
    </div>
    <div>
        <h1>
            <i class="el-icon-s-order icon"></i>
            已归还借用
        </h1>
        <STable :columns="columns" :loadData="loadData4" ref="table3">
           <template #sn='{ $index }'>
             {{ $index + 1 }}
           </template>
           <template #allow="record">
             {{borrowStatus[record.row.allow]}}
           </template>
           <template #license_id="record">
              <a v-if="licenseList.find(item => item.license_id === record.row.license_id)" href="javascript:;" @click="handleOpenDetail(record.row.license_id)">
                  {{ licenseList.find(item => item.license_id === record.row.license_id).license_no }}
              </a>
            </template>
          <template #approve="record">
            {{ filterPeople(record.row.approve) }}
          </template>
           <template #user_id="record">
             {{ filterPeople(record.row.user_id) }}
           </template>
          <template #license_type="record">
             {{ licenseList.find(item => item.license_id === record.row.license_id) ? licenseType[licenseList.find(item => item.license_id === record.row.license_id).license_type] : '' }}
          </template>
          <template #action="record">
              <a href="javascript:;" @click="handleDelete(record.row ,'3')">删除</a>
          </template>
        </STable>
    </div>
     <ItemMoudle :visible.sync='visible' :record='record'/>
  </div>
</template>

<script>
import { initUserInfo } from '@/store/utils';
import { borrowStatus, licenseType} from '@/utils/data'
import ItemMoudle from './ItemMoudle.vue';
import { LicenseBorrowingAndReturning, LicenseManagement } from '@/api/Licence'
import STable from '@/components/STable';
export default {
  components: {
    STable,
    ItemMoudle
  },
  data () {
    return {
      form: {
        license_no: '',
        license_type: '',
        license_name: ''
      },
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100
        },
        {
          label: '证照编号',
          scopedSlots: 'license_id',
          ellipsis: true,
          width: 200
        },
        {
          label: '证照类型',
          scopedSlots: 'license_type',
          ellipsis: true,
          width: 200
        },
        {
          label: '类型',
          prop: 'type',
          width: 200,
          ellipsis: true
        },
        {
          label: '项目名称',
          prop: 'project_name',
          width: 300,
          ellipsis: true
        },
        {
          label: '借阅人',
          scopedSlots: 'approve',
          width: 200,
          ellipsis: true
        },
        {
          label: '被借阅人',
          scopedSlots: 'user_id',
          width: 200,
          ellipsis: true
        },
        {
          label: '申请时间',
          prop: 'add_time',
          width: 200,
          ellipsis: true
        },
        {
          label: '预计归还时间',
          prop: 'return_time',
          width: 200,
          ellipsis: true
        },
        {
          label: '状态',
          scopedSlots: 'allow',
          width: 200,
          ellipsis: true
        },
        {
          label: '操作',
          scopedSlots: 'action',
          fixed: 'right',
          width: 150,
          ellipsis: true
        }
      ],
      loadData1: (pageParam, allow) => {
        const arr = [
          {
            columnName: 'approve',
            columnValue: this.userId,
            filterType: 1,
            tableName: 'oa_form_license_borrow'
          },
          {
            columnName: 'allow',
            columnValue: '0',
            filterType: 1,
            tableName: 'oa_form_license_borrow'
          }
        ]
        return LicenseBorrowingAndReturning.getList(this, { datasourceId: '1631203503424671745', filterDtoList: arr, pageParam }).then(rs => rs)
      },
      loadData2: (pageParam, allow) => {
        const arr = [
          {
            columnName: 'approve',
            columnValue: this.userId,
            filterType: 1,
            tableName: 'oa_form_license_borrow'
          },
          {
            columnName: 'allow',
            columnValue: '1',
            filterType: 1,
            tableName: 'oa_form_license_borrow'
          }
        ]
        return LicenseBorrowingAndReturning.getList(this, { datasourceId: '1631203503424671745', filterDtoList: arr, pageParam }).then(rs => rs)
      },
      
      loadData3: (pageParam, allow) => {
        const arr = [
          {
            columnName: 'approve',
            columnValue: this.userId,
            filterType: 1,
            tableName: 'oa_form_license_borrow'
          },
          {
            columnName: 'allow',
            columnValue: '2',
            filterType: 1,
            tableName: 'oa_form_license_borrow'
          }
        ]
        return LicenseBorrowingAndReturning.getList(this, { datasourceId: '1631203503424671745', filterDtoList: arr, pageParam }).then(rs => rs)
      },
      loadData4: (pageParam, allow) => {
        const arr = [
          {
            columnName: 'approve',
            columnValue: this.userId,
            filterType: 1,
            tableName: 'oa_form_license_borrow'
          },
          {
            columnName: 'allow',
            columnValue: '3',
            filterType: 1,
            tableName: 'oa_form_license_borrow'
          }
        ]
        return LicenseBorrowingAndReturning.getList(this, { datasourceId: '1631203503424671745', filterDtoList: arr, pageParam }).then(rs => rs)
      },
      visible: false,
      record: {},
      peopleList: [], // 人员
      visibleBorrow: false,
      borrowStatus,
      licenseType,
      userId: initUserInfo().userId.toString(),
      licenseList: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      LicenseBorrowingAndReturning.getPeopleList(this, {}).then(res => {
        this.peopleList = res.data.dataList
      })
      LicenseManagement.getList(this, { datasourceId: '1631157465292738560', filterDtoList: [], pageParam: { pageSize: 10000, pageNum: 1} }).then(rs => {
        this.licenseList = rs.data.dataList
      })
    },
    handleOpenDetail (licenseId) {
      this.licenseList.find(item => {
        if (item.license_id === licenseId) {
          this.record = item
          this.visible = true
        }
      })
    },
    submitForm (flag = true) {
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    resetForm () {
      this.form = {
        license_no: '',
        status: '',
        license_name: ''
      }
      this.submitForm()
    },
    filterPeople (id) {
      const item = this.peopleList.find(item => item.userId *1 === id * 1)
      return item ? item.showName : ''
    },
    handleBorrow (record, allow, index) {
      record.allow = allow
      const masterData = record
      this.$confirm('请确认本次操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        LicenseBorrowingAndReturning.updateBorrow(this, {datasourceId: '1631203503424671745', masterData}).then(res => {
          this.$message({
            message: '操作成功!',
            type: 'success'
          });
          if (this.$refs['table' + allow]) this.$refs['table' + allow].refresh(false)
          if (this.$refs['table' + index]) this.$refs['table' + index].refresh(false)
        })
      })
    },
    handleDelete (record, index) {
      this.$confirm('请确认本次操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        LicenseBorrowingAndReturning.deleteBorrow(this, {datasourceId: '1631203503424671745', dataId: record.lend_id}).then(res => {
          this.$message({
            message: '删除成功!',
            type: 'success'
          });
          if (this.$refs['table' + index]) this.$refs['table' + index].refresh(false)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
h1{
  font-size: 25px;
}
</style>
